import { NotFoundView } from 'common/components/NotFound';
import { RoleType } from 'common/models';
import { PrivateRoute } from 'features/auth/components/privateRoute.tsx';
import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { PickPlanView } from './pages/PickPlanView/PickPlanView';

export const PickPlanRoutes: FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <PrivateRoute
        exact
        path={path}
        component={PickPlanView}
        requiredRoles={[
          RoleType.Admin,
          RoleType.Analyst,
          RoleType.FieldRep,
          RoleType.HarvestManager,
        ]}
      />
      <Route path={path} component={NotFoundView} />
    </Switch>
  );
};
